import { useState, useEffect } from 'react';
import axios from 'axios';

import { BASE_URL } from '../utils/constants';

export const useCheckAdmin = () => {
    const [isAdminExist, setAdminExist] = useState(null);

    useEffect(() => {
        axios.get(`${BASE_URL}/UserManagement//CheckIfAdminExists`)
            .then(response => {
                console.log("Setting admin to:", response.data);
                setAdminExist(response.data); // Directly set the response.data as it is a boolean value
            })
            .catch(error => {
                console.error("Error checking if admin exists:", error);
                // TODO: Handle the error appropriately in UI
            });
    }, []);

    return isAdminExist;
};
